import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button, Col, FormControl, FormGroup } from 'react-bootstrap';
import cx from 'classnames';
import Link from '../../components/Link';
import DashboardSideMenu from '../../components/Dashboard/DashboardSideMenu';
import fetch from '../../core/fetch';
import { requestEmailChange } from '../../lib/graphql/user';
import messages from '../../locale/jsonMessages';
import cs from '../../components/commonStyle.css';
import s from './ChangeEmail.css';

const ChangeEmail = ({ intl }) => {
  const { formatMessage } = intl;
  const [email, setEmail] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async event => {
    event.preventDefault();
    setStatus(null);
    if (!email || email !== confirmation) {
      setStatus('mismatch');
      return;
    }
    setLoading(true);
    try {
      const response = await fetch('/graphql', {
        method: 'post',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: requestEmailChange, variables: { newEmail: email } }),
        credentials: 'include',
      });
      const { data } = await response.json();
      setStatus(data?.requestEmailChange?.status || 'failed');
    } catch (error) {
      setStatus('failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
        <DashboardSideMenu isEditProfilePage />
      </Col>
      <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
        <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
          <h2 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom4)}>{formatMessage(messages.changeEmailTitle)}</h2>
          {status === 'pending' ? (
            <p className={s.success}>{formatMessage(messages.changeEmailPending)}</p>
          ) : (
            <form onSubmit={submit}>
              <p>{formatMessage(messages.changeEmailDescription)}</p>
              <FormGroup>
                <label className="commonLabelText">{formatMessage(messages.newEmail)}</label>
                <FormControl className="commonInputField" type="email" value={email} onChange={event => setEmail(event.target.value)} required />
              </FormGroup>
              <FormGroup>
                <label className="commonLabelText">{formatMessage(messages.confirmNewEmail)}</label>
                <FormControl className="commonInputField" type="email" value={confirmation} onChange={event => setConfirmation(event.target.value)} required />
              </FormGroup>
              {status === 'mismatch' && <p className={s.error}>{formatMessage(messages.emailMismatch)}</p>}
              {status === 'email' && <p className={s.error}>{formatMessage(messages.emailAlreadyExists)}</p>}
              {status === 'sameEmail' && <p className={s.error}>{formatMessage(messages.emailSameAsCurrent)}</p>}
              {status === 'failed' && <p className={s.error}>{formatMessage(messages.sentEmailFailed)}</p>}
              <Button className={cx(cs.btnPrimary, cs.btnMedium)} type="submit" disabled={loading}>{formatMessage(messages.sendConfirmationEmail)}</Button>
            </form>
          )}
          <Link to="/user/edit" className={s.backLink}>{formatMessage(messages.backToProfile)}</Link>
        </div>
      </Col>
    </>
  );
};

export default injectIntl(withStyles(cs, s)(ChangeEmail));
